module.exports = __webpack_public_path__ + "img/bk_19_05.92b421db.png";